import React, {Component} from 'react';
import Styles from './style.css';
import {mapRegisterBooster} from "../../services/mapRegisterBooster";
import ReactToPdf from 'react-to-pdf';
import queryString from "query-string";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {langRegister} from "../../services/langRegister";
import {BeatLoader} from "react-spinners";
import {Helmet} from "react-helmet";

import PBfaviconAppleTouch from "../../assets/propertybooster-favicon/apple-touch-icon.png";
import PBfavicon32 from "../../assets/propertybooster-favicon/favicon-32x32.png";
import PBfavicon16 from "../../assets/propertybooster-favicon/favicon-16x16.png";
import PBfaviconSiteManifest from "../../assets/propertybooster-favicon/site.webmanifest";
import PBfaviconSiteSafari from "../../assets/propertybooster-favicon/safari-pinned-tab.svg";

import {dataRegister} from "../../services/dataRegister";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";

const MyMapComponent = mapRegisterBooster.map();

class BoosterPdf extends Component {

    constructor(props) {
        super(props);
        this.state = {
            type: '',
            currency: '',
            price: '',
            location: "",
            image: null,
            broker_image: null,
            broker_name: null,
            broker_phone: null,
            broker_email: null,
            broker_show: false,
            lat: 0,
            lng: 0,
            amenities: [],
            loading: true
        };
    };

    componentWillMount() {
        //window.scrollTo(0, 0);

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/pdf/booster');
            ReactGA4.send({ hitType: "pageview", page: "/pdf/booster" });
        }

        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }
    };

    componentDidMount() {

        let query = queryString.parse(this.props.location.search);

        this.setState({
            reactions: query.reactions ? query.reactions : 0,
            slogans: query.slogans ? query.slogans : [],
            slogan_0: query.slogan_0 ? query.slogan_0 : "",
            slogan_1: query.slogan_1 ? query.slogan_1 : "",
            slogan_2: query.slogan_2 ? query.slogan_2 : "",
            slogan_3: query.slogan_3 ? query.slogan_3 : "",
            impressions: query.impressions ? query.impressions : "",
            lat: query.lat ? parseFloat(query.lat) : null,
            lng: query.lng ? parseFloat(query.lng) : null,
            landingpage_url: query.landingpage_url ? query.landingpage_url : "",
            landingepage_address: query.landingepage_address ? query.landingepage_address : "",
            carousel_ads: query.carousel_ads ? query.carousel_ads : [],
            engagement: query.engagement ? query.engagement : 0,
            branding_pref: query.branding_pref ? query.branding_pref : false,
            branding_primary: query.branding_primary ? query.branding_primary : "",
            branding_secondary: query.branding_secondary ? query.branding_secondary : "",
            type: query.type ? query.type : null,
            list_price: query.list_price ? query.list_price : 0,
            amenities: query.amenities ? query.amenities : [],
            baths: query.baths ? query.baths : 0,
            beds: query.beds ? query.beds : 0,
            property_type: query.property_type ? query.property_type : "",
            property_status: query.property_status ? query.property_status : false,
            furnishings: query.furnishings ? query.furnishings : false,
            price_change: query.price_change ? query.price_change : false,
            just_listed: query.just_listed ? query.just_listed : false,
            old_price: query.old_price ? query.old_price : false,
            industry: query.industry ? query.industry : "",
            location: query.location ? query.location : "",
            sqft: query.sqft ? query.sqft : "",
            image: query.image ? query.image : "",
            currency: query.currency ? query.currency : "",
            broker_image: query.broker_image ? query.broker_image : null,
            broker_phone: query.broker_phone ? query.broker_phone : null,
            broker_email: query.broker_email ? query.broker_email : null,
            broker_name: query.broker_name ? query.broker_name : null,
            broker_company: query.broker_company ? query.broker_company : null,
            broker_permit: query.broker_permit ? query.broker_permit : null,
            broker_whatsapp: query.broker_whatsapp ? query.broker_whatsapp : null,
            broker_logo: query.broker_logo ? query.broker_logo :  "",
            broker_ref: query.broker_ref ? query.broker_ref :  "",
            duration: query.duration ? query.duration :  "",
            description: query.description ? query.description :  ""
        }, () => {

            setTimeout(
                function() {
                    this.setState({ loading: false }, () => {
                        window.print();
                    });
                }.bind(this),
                3000
            );
        });
    }

    componentWillReceiveProps(nextProps, nextContext) {}

    scraper = {};

    init = {};

    functions = {};

    renders = {
        number: (number) => {
            try {
                number = Math.round(number);
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            } catch (e) {
                return ("...")
            }
        },
        sqm: (value) => {
            try{
                return this.renders.number(Math.round(value * 0.093));
            }catch (e) {
                return ("...")
            }
        },
        splitString: (string, id)  => {
            try{
                let split_string = string.split("-");
                split_string = split_string[0].split(",");
                return split_string[id];
            }catch (e) {
                return null
            }
        },
        cleanHex: (hex) => {
            try{
                let split_hex = hex.split("#");
                return "%23" + split_hex[1];
            }catch (e) {
                return null
            }
        }
    };

    _renderReducedPrice() {
        try {
            if (this.state.price_change && this.state.old_price > 0) {
                return Math.round(((this.state.list_price - this.state.old_price) / this.state.old_price) * 100);
            } else {
                return false
            }
        } catch (e) {
            return false
        }
    }

    _renderBadgeSmall() {
        try {
            if (this._renderReducedPrice() && this._renderReducedPrice() !== 0) {
                return this._renderReducedPrice() < 0 ? this._renderText("item_14") + this._renderReducedPrice() + "%" : this._renderText("item_14") + "+" + this._renderReducedPrice() + "%";
            } else if (this.state.just_listed && this.state.property_status && this.state.property_status.toLowerCase() !== this._renderText("item_13")) {
                return this._renderText("item_15");
            } else if ((!this.state.just_listed && this.state.property_status && this.state.property_status.toLowerCase() === this._renderText("item_13")) || (this.state.just_listed && this.state.property_status && this.state.property_status.toLowerCase() === this._renderText("item_13"))) {
                return this._renderText("item_13");
            } else {
                return false;
            }
        } catch (e) {
            return false
        }
    }

    _renderLoader() {
        if (this.state.branding_pref) {
            return '#BFBFBF'
        } else {
            return 'var(--first-color)'
        }
    };

    _renderUrl() {
        if (window.location.hostname.indexOf('dev') === -1) {
            if (salesChannelRegister.get('name') === "propertybooster") {
                return 'lp.propertybooster.io/' + this.state.landingpage_url
            } else if (salesChannelRegister.get('name') === "boostabostad") {
                return 'lp.boostabostad.se/' + this.state.landingpage_url
            }

        } else {
            if (salesChannelRegister.get('name') === "propertybooster") {
                return 'lp.devpropertybooster.com/' + this.state.landingpage_url
            } else if (salesChannelRegister.get('name') === "boostabostad") {
                return 'lp.devboostabostad.se/' + this.state.landingpage_url
            }
        }
    };


    _renderText(item) {
        return langRegister.get("booster-pdf", item);
    };

    render() {
        return (
            <div className={Styles.container}>
                {
                    this.state.loading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={this._renderLoader()} loading={true}/>
                    </div>
                }
                {
                    <div className={Styles.containerInner}>
                        <div className={Styles.containerInnerLeft}>
                            {
                                !this.state.branding_pref &&
                                <div className={Styles.logoContainer}>
                                <img className={Styles.logo}
                                     src={salesChannelRegister.get('logo')}/>
                                </div>
                            }
                            {
                                this.state.branding_pref &&
                                <div className={Styles.logoContainer}>
                                <img className={Styles.logoBranding}
                                     src={this.state.broker_logo}/>
                                </div>
                            }
                            <div className={Styles.containerInnerLeftViews}>
                                {
                                    this.state.impressions > 0 &&
                                    <div className={Styles.containerImageViews}>
                                        {this.renders.number(this.state.impressions)}{this._renderText("item_1")}
                                    </div>
                                }
                                {
                                    (this.state.engagement > 0 || this.state.reactions > 0) &&
                                    <img className={Styles.sectionThreeLeftTopShareMobileHeart}
                                         src={require('../../assets/images/heart.svg')}/>
                                }
                                {
                                    (this.state.engagement > 0 || this.state.reactions > 0) &&
                                    <div className={Styles.containerImageEngagement}>
                                        {this.renders.number((parseInt(this.state.engagement) + parseInt(this.state.reactions)))}
                                    </div>
                                }
                                {
                                    (this.state.impressions < 1 && this.state.engagement < 1 && this.state.reactions < 1) &&
                                    <div className={Styles.containerImageViewsPlaceholder}/>
                                }
                            </div>
                                <div>
                                    <div className={Styles.containerInnerLeftSlogan}>
                                        {this.state.slogan_2}
                                    </div>
                                    <div style={this.state.branding_pref ? {color: this.state.branding_secondary} : {}} className={Styles.containerInnerLeftType}>
                                        {this.state.industry}
                                    </div>
                                </div>
                            <div className={Styles.containerInnerLeftInfoDivider}></div>
                            {
                                <div className={Styles.containerInnerLeftThumbs}>
                                    {
                                        Array.isArray(this.state.carousel_ads) &&
                                        <div className={Styles.containerInnerRightPropertyAmenitiesRight}>
                                            {
                                                this.state.carousel_ads.filter((item, index) => {

                                                    return index < this.state.carousel_ads.length-1
                                                }).map((item, index) => {
                                                    if (index === 0 || index === 1 || index === 3 || index === 4 || index === 6 || index === 7) {
                                                        return (
                                                            <img
                                                                className={Styles.containerInnerLeftThumbsItemEven}
                                                                src={item}/>

                                                        )
                                                    } else {
                                                        return (
                                                            <img
                                                                className={Styles.containerInnerLeftThumbsItemOdd}
                                                                src={item}/>

                                                        )
                                                    }
                                                    })
                                            }
                                        </div>
                                    }
                                </div>
                            }
                            {
                                <div className={Styles.containerInnerLeftFaqItem}>
                                    <div className={Styles.containerInnerLeftFaqItemTitle}>
                                        {this._renderText("item_5")}
                                    </div>
                                    {
                                        !this.state.description &&
                                        <div className={Styles.containerInnerLeftFaqItemText}>
                                            {this.state.slogan_0}{" – "}{this.state.slogan_1}{" – "}{this.state.slogan_2}{" – "}{this.state.slogan_3}
                                        </div>
                                    }
                                    {
                                        this.state.description &&
                                        <div className={Styles.containerInnerLeftFaqItemText}>
                                            {this.state.description}
                                        </div>
                                    }
                                </div>
                            }
                            <div className={Styles.containerInnerLeftSpace}/>
                            <div className={Styles.containerInnerLeftDisclaimer}>
                                <div className={Styles.containerInnerLeftDisclaimerTitle}>
                                    {this._renderText("item_6")}
                                </div>
                                <div className={Styles.containerInnerLeftDisclaimerText}>
                                    {this._renderText("item_7")}
                                </div>
                            </div>
                        </div>
                        <div className={Styles.containerInnerCenter}>
                        </div>
                        <div className={Styles.containerInnerRight}>
                            <div className={Styles.containerInnerRightTop}>
                                    <div className={Styles.containerInnerRightTopUrl}>
                                        {this._renderUrl()}
                                    </div>
                                <div className={Styles.containerInnerRightTopBroker}>
                                    <div style={!this.state.broker_image?{textAlign: "right"}:{}} className={Styles.containerInnerRightTopBrokerInfo}>
                                        <div>
                                            <div className={Styles.containerInnerRightTopBrokerInfoTitle}>
                                                {this._renderText("item_2")}
                                            </div>
                                            <div className={Styles.containerInnerRightTopBrokerInfoName}>
                                                {this.state.broker_name}
                                            </div>
                                            <div className={Styles.containerInnerRightTopBrokerInfoEmail}>
                                                {this.state.broker_email}
                                            </div>
                                            <div className={Styles.containerInnerRightTopBrokerInfoPhone}>
                                                {this.state.broker_phone}
                                            </div>
                                            <div className={Styles.containerInnerRightTopBrokerInfoButtons}>
                                                <a href={"tel:" + this.state.broker_phone}>
                                                    <div style={this.state.branding_pref ? {backgroundColor: this.state.branding_primary} : {}} className={Styles.containerInnerRightTopBrokerInfoButtonsItem}>
                                                        <img style={{width: '12px'}}
                                                             src={require('../../assets/images/phone_icon_white.png')}/>
                                                    </div>
                                                </a>
                                                <a href={"https://wa.me/" + this.state.broker_phone + "/?text=Hey"}>
                                                    <div style={this.state.branding_pref ? {backgroundColor: this.state.branding_primary} : {}} className={Styles.containerInnerRightTopBrokerInfoButtonsItem}>
                                                        <img style={{width: '11px'}}
                                                             src={require('../../assets/images/whatsapp_white.png')}/>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        this.state.broker_image &&
                                        <div style={{backgroundImage: 'url(' + this.state.broker_image + ')'}} className={Styles.containerInnerRightTopBrokerImage}></div>
                                    }
                                </div>
                            </div>
                            <div
                                className={Styles.containerInnerRightProperty}>
                                {
                                    this.state.location &&
                                    <div className={Styles.containerInnerRightPropertyLocation}>
                                        {this.state.location + ", " + this.renders.splitString(this.state.landingepage_address, 0)}
                                    </div>
                                }
                                {
                                    this.state.list_price > 0 && this.state.type === "sale" &&
                                <div style={this.state.branding_pref ? {color: this.state.branding_primary} : {}} className={Styles.containerInnerRightPropertyName}>
                                    {this.state.currency}{" "}{this.renders.number(this.state.list_price)}
                                </div>
                                }
                                {
                                    this.state.list_price > 0 && this.state.type === "rent" &&
                                    <div style={this.state.branding_pref ? {color: this.state.branding_primary} : {}} className={Styles.containerInnerRightPropertyName}>
                                        {this.state.currency}{" "}{this.renders.number(this.state.list_price)}{" "}{this.state.duration}
                                    </div>
                                }
                                {
                                    this.state.list_price < 1 &&
                                    <div style={this.state.branding_pref ? {color: this.state.branding_primary} : {}} className={Styles.containerInnerRightPropertyName}>
                                        {this._renderText("item_12")}
                                    </div>
                                }
                            </div>
                            <div style={{backgroundImage: 'url(' + this.state.image + ')'}} className={Styles.containerInnerRightPropertyImage}>
                                {
                                    this.state.property_status && this._renderBadgeSmall() &&
                                    <div style={this.state.branding_pref ? { borderTop: "calc(var(--size-factor) * 70px) solid " + this.state.branding_primary } : { borderTop: "calc(var(--size-factor) * 70px) solid #CC5430" }} className={Styles.containerInnerRightPropertyImagetriangleSmall}></div>
                                }
                                {
                                    this.state.property_status && this._renderBadgeSmall() &&
                                    <div style={this.state.branding_pref ? { backgroundColor: this.state.branding_primary } : { backgroundColor: "#CC5430" }} className={Styles.containerInnerRightPropertyImageBadgeSmall}>
                                        {this._renderBadgeSmall()}
                                    </div>
                                }
                            </div>
                            <div className={Styles.containerInnerRightPropertyAmenities}>
                                <div className={Styles.containerInnerRightPropertyAmenitiesLeft}>
                                    <div className={Styles.containerInnerRightPropertyAmenitiesLeftItem}>
                                        {this.state.beds}{this.state.beds > 1 ? this._renderText("item_8") : this._renderText("item_9")}{" "}{this.state.property_type === "rent" ? " | " + this.state.furnishings : " | " + this.state.property_status}
                                    </div>
                                    <div className={Styles.containerInnerRightPropertyAmenitiesLeftItem}>
                                        {this.state.baths}{" "}{this.state.baths > 1 ? this._renderText("item_10") : this._renderText("item_11")}
                                    </div>
                                    {
                                        this.state.sqft && this.state.sqft > 0 && salesChannelRegister.get('name') === "propertybooster" &&
                                    <div className={Styles.containerInnerRightPropertyAmenitiesLeftItem}>
                                        {this.renders.number(this.state.sqft)}{" "}{this._renderText("item_3")} | {this.renders.sqm(this.state.sqft)}{" "}{this._renderText("item_4")}
                                    </div>
                                    }
                                    {
                                        this.state.sqft && this.state.sqft > 0 && salesChannelRegister.get('name') === "boostabostad" &&
                                        <div className={Styles.containerInnerRightPropertyAmenitiesLeftItem}>
                                            {this.renders.sqm(this.state.sqft)}{" "}{this._renderText("item_4")} | {this.renders.number(this.state.sqft)}{" "}{this._renderText("item_3")}
                                        </div>
                                    }
                                </div>
                                {
                                    Array.isArray(this.state.amenities) &&
                                    <div className={Styles.containerInnerRightPropertyAmenitiesRight}>
                                        {
                                            this.state.amenities.filter((item, index) => {
                                                return index < 3
                                            }).map((item) => {
                                                return (
                                                    <div
                                                        className={Styles.containerInnerRightPropertyAmenitiesRightItem}>
                                                        <div
                                                            className={Styles.containerInnerRightPropertyAmenitiesRightItemText}>
                                                            {item}
                                                        </div>
                                                        {

                                                            <div className={Styles.containerInnerRightPropertyAmenitiesRightItemCheckmark}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="12px" height="10px" viewBox="0 0 25 20">
                                                                    <polyline fill="none" stroke={this.state.branding_pref? this.state.branding_primary : "#CC5430"} stroke-width="4.5" stroke-miterlimit="10" points="2.5,9.133 8.915,15.602 22.541,2 "/>
                                                                </svg>
                                                            </div>
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                }
                            </div>
                            <div className={Styles.containerInnerRightPropertyMap}>
                                {
                                    this.state.lat && this.state.lng &&
                                    <MyMapComponent
                                        googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCNIJwUJ8ggv72a2YwgF8HSLUDj6BYqAv8&v=3.56&libraries=geometry,drawing,places"
                                        loadingElement={<div style={{height: `100%`}}/>}
                                        containerElement={<div className={Styles.containerContentMap}/>}
                                        mapElement={<div style={{height: `100%`}}/>}
                                        lat={this.state.lat}
                                        lng={this.state.lng}
                                        branding_primary={this.state.branding_pref? this.renders.cleanHex(this.state.branding_primary) : this.renders.cleanHex("#CC5430")}
                                    />
                                }
                            </div>
                            <div className={Styles.containerInnerLeftSpace}/>
                            <div className={Styles.containerInnerRightPropertyImages}>
                                <div className={Styles.containerInnerRightPropertyImagesLogo}>
                                    {
                                        this.state.branding_pref &&
                                        <img className={Styles.containerInnerRightPropertyImagesLogoItem}
                                             src={salesChannelRegister.get('logo')}/>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default BoosterPdf;


// WEBPACK FOOTER //
// ./src/pages/booster-pdf/component.js